// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-caracteres {
  overflow-y: auto;
  margin-left: 2em;
}

.table-caracteres .header {
  margin: 1em 0.5em;
}

.table-caracteres .header .liste {
  margin-bottom: 0.5em;
}

.table-caracteres .header label {
  margin-right: 1em;
}

.table-caracteres .header input {
  width: 15em;
}

.table-caracteres .characters {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.table-caracteres .characters .unicode {
  margin: 0.5em;
}

.table-caracteres .characters .unicode button {
  height: 2em;
  width: 2.5em;
  font-size: 1.25em;
}

.table-caracteres .characters .unicode p {
  margin: 0;
}

.table-caracteres .characters .unicode-decimal {
  font-size: 80%;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/table-caracteres/table-caracteres.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".table-caracteres {\r\n  overflow-y: auto;\r\n  margin-left: 2em;\r\n}\r\n\r\n.table-caracteres .header {\r\n  margin: 1em 0.5em;\r\n}\r\n\r\n.table-caracteres .header .liste {\r\n  margin-bottom: 0.5em;\r\n}\r\n\r\n.table-caracteres .header label {\r\n  margin-right: 1em;\r\n}\r\n\r\n.table-caracteres .header input {\r\n  width: 15em;\r\n}\r\n\r\n.table-caracteres .characters {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.table-caracteres .characters .unicode {\r\n  margin: 0.5em;\r\n}\r\n\r\n.table-caracteres .characters .unicode button {\r\n  height: 2em;\r\n  width: 2.5em;\r\n  font-size: 1.25em;\r\n}\r\n\r\n.table-caracteres .characters .unicode p {\r\n  margin: 0;\r\n}\r\n\r\n.table-caracteres .characters .unicode-decimal {\r\n  font-size: 80%;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
